import React, { useState, useEffect } from 'react';
import PropTypes from "prop-types";
import { makeStyles } from "@mui/styles";
import DataTable from "react-data-table-component";
import styled from "styled-components";

const NoData = styled.p`
  font-size: 14px;
  font-weight: 600;
  margin-top: 20px;
  opacity: 1;
`;


const useStylesTable = makeStyles((theme) => ({
    root: {

        '&.rdt_TableHeader': {

        },

    },
}));

export function ShowDataGrid(props) {

    // const [ page , setPage] = useState(0);
    // const [ pageSize , setPageSize]=useState(10);
    const styledTable = useStylesTable();
    const customStyles = {
        rows: {
            style: {
                backgroundColor: '#242f3e',
                color: "#FFFFFF",
                '&:not(:last-of-type)': {
                    borderBottomStyle: 'solid',
                    borderBottomWidth: '1px',
                    borderBottomColor: '#e6e5eb',
                },
            },
        },
        headRow: {
            style: {
                borderBottomColor: '#e6e5eb',
                borderBottomWidth: '1px',
                fontSize : '13px',
            },
        },
        headCells: {
            style: {
                backgroundColor: '#242f3e',
                color: "#FFFFFF"
            },
        },
        cells: {
            style: {
                backgroundColor: '#242f3ebd',
                color: "#FFFFFF"
            },
            selectedHighlightStyle: {
                // use nth-of-type(n) to override other nth selectors
                '&:nth-of-type(n)': {
                    backgroundColor: '#242f3ebd',
                },
            },
        },
        pagination: {
            style: {
                color:  "#FFFFFF",
                fontSize: '13px',
                backgroundColor: '#242f3ebd',
                borderTopStyle: 'solid',
                borderTopWidth: '1px',
                borderTopColor: '#e6e5eb',
            },
            pageButtonsStyle: {
                color: "#FFFFFF",
                //fill: theme.button.default,
                backgroundColor: 'transparent',
                '&:disabled': {
                    cursor: 'unset',
                    color: '#929292',
                    // fill: theme.button.disabled,
                },
                // '&:hover:not(:disabled)': {
                //     backgroundColor: theme.button.hover,
                // },
                // '&:focus': {
                //     outline: 'none',
                //     backgroundColor: theme.button.focus,
                // },
            },
        },
        noData: {
            style: {
                backgroundColor: '#242f3ebd',
                color: "#FFFFFF",
                paddingTop: "10px",
            },
        },
    };


    return (
        <DataTable
            paginationRowsPerPageOptions={[10, 20, 30, 50, 100]}
            className={styledTable.root}
            customStyles={customStyles}
            noDataComponent={<NoData>Aucune donnée</NoData>}
            noHeader={true}
            dense
            columns={props.columns}
            persistTableHead
            pagination
            highlightOnHover
            pointerOnHover
            expandableRowDisabled={(row) => row.disabled}
            paginationComponentOptions={{
                noRowsPerPage: true,
                rowsPerPageText: "Lignes par page",
                rangeSeparatorText: "sur",
                selectAllRowsItem: false,
                selectAllRowsItemText: "Selectionner toutes les lignes",
            }}
            onRowClicked={(row) => {
                props.onRowClick(row);
            }}
            paginationPerPage={20}
            defaultSortFieldId={1}
            data={props.rows}
            paginationTotalRows={props.rows ? props.rows.length : 0}
            filterable={true}
            manual={true}
            onRowMouseEnter={(row) => {
                props.onRowOver(row);
            }}
            onRowMouseLeave={(row) => {
                props.onRowOut(row);
            }}
        />
    );
}

ShowDataGrid.propTypes = {
    columns: PropTypes.array,
    rows: PropTypes.array,
    onRowClick: PropTypes.func,
    onRowOver: PropTypes.func,
    onRowOut: PropTypes.func
}